import { createApp } from 'vue'
import App from './App.vue'
import { createAuth } from '@/plugins/auth'
import { router } from './router'
import { api } from './store/api'


const auth = createAuth({
    router,
    axios: api,
    refresh_interval: 30
    
}) 

const start = async () => {
    try {
        await auth.fetch()
        //await auth.refresh()
        
    } catch (error) {
        
    }
    const app = createApp(App)
    app
        .use(router)
        .use(auth)
        .mount('#app')
}

start()






if (import.meta.hot) {
    import.meta.hot.accept()
}